var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6895 0.326507C14.5045 0.141337 14.2852 0.0488281 14.0318 0.0488281H0.935529C0.682014 0.0488281 0.46285 0.141337 0.277679 0.326507C0.0925085 0.511883 0 0.731047 0 0.984408C0 1.23772 0.0925085 1.45688 0.277679 1.6421L6.82582 8.19024C7.01119 8.37542 7.23036 8.46813 7.48367 8.46813C7.73698 8.46813 7.95635 8.37542 8.14137 8.19024L14.6895 1.64205C14.8745 1.45688 14.9673 1.23772 14.9673 0.984357C14.9673 0.731047 14.8745 0.511883 14.6895 0.326507Z",
    fill: "#919BAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownIcon);
export default __webpack_public_path__ + "static/media/dropDownIcon.ed024e40bf0ee671ba78aae3da9d918e.svg";
export { ForwardRef as ReactComponent };